import { pluralize, type Vars } from '@porotutu/i18n'
import { guestLocale } from './locale'
import { useMaybeSession } from './useSession'

export function useCount(): (key: string, count: number, vars?: Vars) => string {
  const locale = useMaybeSession()?.locale ?? guestLocale()

  return (key, count, vars = {}) => pluralize(locale, key, count, vars)
}
